










import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      open: false,
    };
  },
  mounted() {
    this.listen();
  },
  methods: {
    listen() {
      document.addEventListener("onLogout", () => {
        window.localStorage.clear();
        this.open = true;
      });
    },
  },
});
